import React, { useEffect, useState } from "react";
import AppLayout from "../../core/layouts/AppLayout";
import "../../styles/listing.scss";

import Moment from "react-moment";
import moment from "moment";
import classnames from "classnames";
import {
  ListTable,
  ListTableColumn,
  ListHeader,
  Dict,
  FilterValueType,
  getFilters,
  PaginatedApiResponse,
  ListSort,
  SortOrder,
  QueryFilter,
  ListFilters,
  ListHeaderSearch,
  MultiSelectFilter,
  ListColumnSettings,
  SavedFilter,
  ListEntityType,
  Column,
  useLead,
  useConfiguration,
  PaidBy,
  SingleSelectFilter,
  City,
  convertPascalCaseToWords,
} from "../../core";
import { State } from "../../core/store/interfaces";
import { useMasterData } from "../../core/hooks/useMasterData";
import api from "../../api";
import { useDataLoader, usePerformAction } from "react-remote-data-hooks";
import { ContainerLoader, Spinner } from "../../components/loader";
import { useHistory, useLocation } from "react-router-dom";
import queryString, { ParsedQuery } from "query-string";

import DateRangeListFilter, {
  IDateRange,
} from "../../core/components/list-filters/DateRangeListFilter";
import Pagination from "../../core/components/pagination/Pagination";
import { toastr } from "react-redux-toastr";
import { LeadRequirement } from "../../core/api/models/requirement";
import { decodeHtmlEntities } from "../../utils/common";
import MainTabs from "./MainTabs";
import MultiSelectFilterWithApiSearch from "../../core/components/list-filters/MultiSelectFilterWithApiSearch";
import { EmptyPersonColumn, SalesPersonColumn } from "../../components/list-columns";
import { DownloadLink } from "../../components/render-file/DownloadLink";

const tableContent = [
<ListTableColumn
  label="Lead Intent"
  source="invoiceDetails.leadDetails.leadIntent.name"
  column="leadIntent"
  showDefault
  sortable
  settingsGroup="Requirement"
></ListTableColumn>,
<ListTableColumn
  label="Lead Title"
  source="invoiceDetails.leadDetails.title"
  column="leadTitle"
  showDefault
  sortable
  settingsGroup="Requirement"
></ListTableColumn>,
//   <ListTableColumn
//   label="Lead Type"
//   source="invoiceDetails.leadDetails.leadType.name"
//   column="leadType"
//   showDefault
//   sortable
//   settingsGroup="Requirement"
// ></ListTableColumn>,
<ListTableColumn
  label="Company Name"
  source="invoiceDetails.leadDetails.company.name"
  column="name"
  showDefault
  sortable
  settingsGroup="Requirement"
></ListTableColumn>,
<ListTableColumn
  label="Contact Name"
  source="invoiceDetails.leadDetails.customer.fullName"
  column="fullName"
  showDefault
  sortable
  settingsGroup="Requirement"
></ListTableColumn>,
<ListTableColumn
  label="Phone"
  source="invoiceDetails.leadDetails.customer"
  column="invoiceDetails.leadDetails.customer"
  formatContent={(data)=><span>{data.primaryPhone || data.phone}</span>}
  showDefault
  sortable
  settingsGroup="Requirement"
></ListTableColumn>,
<ListTableColumn
  label="Created By"
  source="invoiceDetails.createdBy.name"
  column="invoiceDetails.createdBy.name"
  showDefault
  sortable
  settingsGroup="Requirement"
></ListTableColumn>,
<ListTableColumn
  label="Created Date & Time"
  source="createdAt"
  column="Created Date & Time"
  showDefault
  formatContent={(d: string | Date | moment.Moment) =>
    moment(d).format("DD MMM YYYY hh:mm A")
  }
  sortable
  settingsGroup="Requirement"
></ListTableColumn>,
<ListTableColumn
  label="Payment Mode"
  source="paymentMethod"
  column="paymentMethod"
  formatContent={(cont: string ) =>convertPascalCaseToWords(cont)
  }
  showDefault
  sortable
  settingsGroup="Requirement"
></ListTableColumn>,
<ListTableColumn
  label="Payment Date &Time"
  source="paidAt"
  column="Payment Date & Time"
  showDefault
  formatContent={(d: string | Date | moment.Moment) =>
    moment(d).format("DD MMM YYYY hh:mm A")
  }
  sortable
  settingsGroup="Requirement"
></ListTableColumn>,
  <ListTableColumn
  label="Invoice Date"
  column="Invoice Date"
  source="invoiceDetails.document.paymentDetails.date"
  formatContent={(d: string | Date | moment.Moment) =>
    moment(d).format("DD MMM YYYY")
  }
  showDefault
  sortable
  settingsGroup="Requirement"
></ListTableColumn>,
<ListTableColumn
  label="Due Date"
  column="Due Date"
  source="invoiceDetails.document.paymentDetails.dueDate"
  formatContent={(d: string | Date | moment.Moment) =>
    <span className={moment(d).endOf('day').isBefore(moment().endOf('day')) ? 'text-danger' : ''}>{moment(d).format("DD MMM YYYY")}</span>
  }
  showDefault
  sortable
  settingsGroup="Requirement"
></ListTableColumn>,
    <ListTableColumn
    label="Transaction Manager"
    source="invoiceDetails.leadDetails.currentSalesPerson.name"
    column="invoiceDetails.leadDetails.currentSalesPerson.name"
    settingsGroup="Person"
    // formatContent={(user) => {
    //   return <SalesPersonColumn user={user} />;
    // }}
    showDefault
    // nullContent={<EmptyPersonColumn />}
  ></ListTableColumn>,
  <ListTableColumn
  label="Paid by"
  source="paidBy"
  column="paidBy"
  showDefault
  sortable
  settingsGroup="Requirement"
></ListTableColumn>,
  <ListTableColumn
  label="Bank"
  source="bank"
  column="bank"
  showDefault
  sortable
  settingsGroup="Requirement"
></ListTableColumn>,
  <ListTableColumn
  label="Comments"
  source="comments"
  column="comments"
  showDefault
  sortable
  settingsGroup="Requirement"
></ListTableColumn>,
  <ListTableColumn
  label="Receipt Download"
  source="receipt"
  formatContent={(d) =>
    <span >
      <DownloadLink className="text-primary" file={d} target="_blank">
        View
      </DownloadLink>
   </span>
  }
  column="receipt"
  showDefault
  sortable
  settingsGroup="Requirement"
></ListTableColumn>,
  <ListTableColumn
  label="Refund Amount"
  source="refundAmount"
  column="refundAmount"
  showDefault
  sortable
  settingsGroup="Requirement"
></ListTableColumn>,
  <ListTableColumn
  label="Refund Reason"
  source="reason"
  column="reason"
  showDefault
  sortable
  settingsGroup="Requirement"
></ListTableColumn>,
  <ListTableColumn
  label="Status"
  source="status"
  column="status"
  formatContent={(value)=><span>{convertPascalCaseToWords(value)}</span>}
  showDefault
  sortable
  settingsGroup="Requirement"
></ListTableColumn>,
<ListTableColumn
  label="Amount Paid"
  source="amount"
  formatContent={(value)=><span>₹{value}</span>}
  column="amount"
  showDefault
  sortable
  settingsGroup="Requirement"
></ListTableColumn>,
<ListTableColumn
  label="Invoice Amount"
    source="invoiceDetails.document.paymentDetails.amount"
  formatContent={(value)=><span>₹{value}</span>}
  column="Invoice Amount"
  showDefault
  sortable
  settingsGroup="Requirement"
></ListTableColumn>,
<ListTableColumn
  label="SGST"
  source="invoiceDetails.document.paymentDetails.taxSgst"
  formatContent={(value)=><span>₹{value}</span>}
  column="SGST"
  showDefault
  sortable
  settingsGroup="Requirement"
></ListTableColumn>,
<ListTableColumn
  label="CGST"
  source="invoiceDetails.document.paymentDetails.taxCgst"
  formatContent={(value)=><span>₹{value}</span>}
  column="CGST"
  showDefault
  sortable
  settingsGroup="Requirement"
></ListTableColumn>,
<ListTableColumn
  label="Net Amount"
  source="invoiceDetails.document.paymentDetails.netAmount"
  formatContent={(value)=><span>₹{value}</span>}
  column="Net Amount"
  showDefault
  sortable
  settingsGroup="Requirement"
></ListTableColumn>,
];

const TransactionList: React.FunctionComponent = () => {
  const history = useHistory();
  const params = useLocation().search;
  const masterData = useMasterData(api.settings);
  const [search, setSearch] = useState("");
  const [filters, setFilters] = useState<Dict<FilterValueType>>({});

  const [mainTabName, setMainTabName] = useState<PaidBy>(PaidBy.Client);

  const { data: leadSettings, reload: reloadSettings } = useDataLoader<{
    filters: SavedFilter[];
    columnSettings?: ListColumnSettings;
  }>(() => api.settings.getListColumnSettings(ListEntityType.Transaction360));

  const {
    performAction: saveFilter,
    isPerforming: savingFilter,
  } = usePerformAction(
    (fls: Dict<FilterValueType>, name: string) =>
      api.settings.saveFilter(fls, name, ListEntityType.Transaction360),
    () => {
      toastr.success("Success", "Filter Saved");
      reloadSettings();
    },
    () => {
      toastr.error("Error", "Unable to save filter");
    }
  );

  const { performAction: saveColumnSettings } = usePerformAction(
    (cols: Column[]) =>
      api.settings.saveListColumnSettings(cols, ListEntityType.Transaction360),
    reloadSettings
  );

  const { performAction: removeFilter } = usePerformAction(
    (_id: string) => api.settings.removeSavedFilter(_id),
    () => {
      toastr.success("Success", "Filter Removed");
      reloadSettings();
    },
    () => {
      toastr.error("Error", "Unable to remove filter");
    }
  );

  const loadFromQuery = () => {
    const queryFilter: QueryFilter = {};
    const queries: ParsedQuery<string> = queryString.parse(params);
    queryFilter.query = queries.query as string;
    if (queries.filters) {
      queryFilter.filters = JSON.parse(queries.filters?.toString());
    }
    if (queries.page) {
      queryFilter.page = Number(queries.page || 1);
    }
    if (queries.perPage) {
      queryFilter.perPage = Number(queries.perPage || 1);
    }
    if (queries.startDate) {
      queryFilter.startDate = moment(queries.startDate as string).toDate();
    }
    if (queries.endDate) {
      queryFilter.endDate = moment(queries.endDate as string).toDate();
    }

    if (queries.sort) {
      queryFilter.sort = JSON.parse(queries.sort?.toString());
    }

    if (queries.listView) {
      queryFilter.listView = queries.listView?.toString();
    }

    return queryFilter;
  }

  const [dateFilters, setDateFilters] = useState<IDateRange | undefined>({
    startDate: loadFromQuery()?.startDate,
    endDate: loadFromQuery()?.endDate,
  });

  const [sort, setSort] = useState<ListSort>({
    sortBy: loadFromQuery()?.sort?.sortBy || "createdAt",
    sortOrder: loadFromQuery()?.sort?.sortOrder || SortOrder.DESC,
  });

  const [transactionExecutive, setTransactionExecutive] = useState<any>([]);
  const [propertyType, setPropertyType] = useState<any>([]);
  const [userList, setUserList] = useState<any>([]);
  const [page, setPage] = React.useState(loadFromQuery()?.page || 1);
  const [perPage, setPerPage] = React.useState(loadFromQuery()?.perPage || 20);

  const { data, loading, loaded, reload } = useDataLoader<
    PaginatedApiResponse<LeadRequirement> & { lastUpdatedAt: Date }
  >(
    (
      searchTerm: string | undefined,
      searchFilters: Dict<FilterValueType>,
      currentPage: number,
      pageCount: number,
      searchOrder?: ListSort,
      dates?: IDateRange
    ) => {

      const currentFilter = {
        ...getFilters(loadFromQuery()?.filters || searchFilters),
      };

      return api.invoice.getTransaction360List({
        ...currentFilter,
        fromDate: dates?.startDate
          ? moment(dates?.startDate).startOf("day").toDate()
          : undefined,
        toDate: dates?.endDate
          ? moment(dates?.endDate).endOf("day").toDate()
          : undefined,
        page: currentPage,
        query: loadFromQuery()?.query || searchTerm,
        sortBy: searchOrder?.sortBy || 'createdAt',
        sortOrder: searchOrder?.sortOrder || SortOrder.DESC,
        perPage: pageCount,
        invoiceCopyType: mainTabName
      });
    },
    [search, filters, page, perPage, sort, dateFilters, mainTabName]
  );

  useEffect(() => {
    if (loaded) {
      setPage(1);
      onChangeFilter(filters, search, 1, perPage, dateFilters, sort);
      reload(search, filters, 1, perPage, sort, dateFilters);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, filters, sort, perPage, dateFilters, mainTabName]);

  useEffect(() => {
    if (loaded) {
      reload(search, filters, page, perPage, sort, dateFilters);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  React.useEffect(() => {
    const filterResonse = loadFromQuery();

    if (filterResonse.query) {
      setSearch(filterResonse.query as string);
    }

    if (filterResonse.filters) {
      if (
        filterResonse.filters?.autolineStatus &&
        Array.isArray(filterResonse.filters.autolineStatus)
      ) {
        filterResonse.filters.autolineStatus = filterResonse.filters.autolineStatus?.filter(
          (x: any) => x.value !== "PreVin" && x.value !== "Produced"
        );
        if (!filterResonse.filters.autolineStatus?.length) {
          delete filterResonse.filters.autolineStatus;
        }
      }
      setFilters(filterResonse.filters);
    }

    if (filterResonse.page) {
      setPage(filterResonse.page);
    }
    if (filterResonse.perPage) {
      setPerPage(filterResonse.perPage);
    }
  }, []);

  useEffect(() => {
    const handleFilterOptionsApi = async () => {
      try {
        const propertyTypeData = await api.AddNewRequirement.getPropertyType();
        const subTypes = propertyTypeData.reduce((acc: any, item: any) => {
          acc.push(
            ...item.subTypes.map(
              (subType: { _id: any; propertyTypeName: any }) => ({
                value: subType._id,
                name: decodeHtmlEntities(subType.propertyTypeName),
              })
            )
          );
          return acc;
        }, []);
        setPropertyType(subTypes);
      } catch (error) {
        // console.log("Failed to fetch property type data:", error);
      }

      try {
        const transactionExecutiveData = await api.user.getCrmAgents({
          sortBy: "name",
          sortOrder: SortOrder.ASC,
        })

        const transactionExecutiveOptions = transactionExecutiveData?.map((item: any) => ({
          value: item._id,
          name: decodeHtmlEntities(item?.name),
        }));
        setTransactionExecutive(transactionExecutiveOptions)
      } catch (error) {
        // console.log("Failed to fetch property type data:", error);
      }
      try {
        const userListData = await api.user.getUserList();
        const userListDataOptions = userListData?.map((item: any) => ({
          value: item._id,
          name: decodeHtmlEntities(item?.name),
        }));
        setUserList(userListDataOptions)
      } catch (error) {
        // console.log("Failed to fetch property type data:", error);
      }
    };

    handleFilterOptionsApi()
  }, [])

  const [selected, setSelected] = useState<string[]>([]);

  const onSaveFilter = (name: string) => {
    saveFilter(filters, name);
  };

  const { data: allPropertyType } = useDataLoader<City[]>(() =>
    api.AddNewRequirement.getPropertyType()
  );

  const onRemoveFilter = (_id: string) => {
    removeFilter(_id);
  };

  const onChangeFilter = (
    searchFilters: Dict<FilterValueType>,
    searchValue: string,
    currentPage: number,
    numberOfPages: number,
    dates?: IDateRange,
    sortOption?: ListSort
  ) => {
    let query = `query=${encodeURIComponent(
      searchValue
    )}&page=${currentPage}&perPage=${numberOfPages}`;

    if (
      getFilters(searchFilters) &&
      Object.keys(getFilters(searchFilters)).length
    ) {
      query =
        query + `&filters=` + encodeURIComponent(JSON.stringify(searchFilters));
    }
    if (dates?.startDate) {
      query =
        query + `&startDate=` + moment(dates?.startDate).format("DD-MMM-YYYY");
    }
    if (dates?.endDate) {
      query =
        query + `&endDate=` + moment(dates?.endDate).format("DD-MMM-YYYY");
    }
    if (sortOption && sortOption.sortBy) {
      query = query + `&sort=` + JSON.stringify(sortOption);
    }
    history.replace(`/transaction360?${query}`);
  };

  const filterRow = (
    <ListFilters
      key="filter-row"
      savedFilters={leadSettings?.filters || []}
      onSaveFilter={onSaveFilter}
      isSavingFilter={savingFilter}
      onRemoveFilter={onRemoveFilter}
      filters={filters}
      onFilter={(searchFilters: Dict<FilterValueType>) => {
        onChangeFilter(searchFilters, search, page, perPage, dateFilters, sort);
        setFilters(searchFilters);
      }}
    >
      <MultiSelectFilter
        label="Lead Intent"
        filterKey="leadIntent"
        key="leadIntent"
        allowSearch
        options={masterData.data?.leadIntents || []}
        valueField="_id"
        labelField="name"
      />
      <MultiSelectFilter
        label="Payment Methods"
        filterKey="paymentMethods"
        key="paymentMethods"
        allowSearch
        options={[
          { _id: 'cash', name: 'Cash' },
          { _id: 'bankTransfer', name: 'Bank Transfer' },
          { _id: 'creditCard', name: 'Credit Card' },
          { _id: 'debitCard', name: 'Debit Card' },
          { _id: 'cheque', name: 'Cheque' }
        ]}
        valueField="_id"
        labelField="name"
      />
      {/* <MultiSelectFilter
        label="Lead Type"
        filterKey="leadType"
        key="leadType"
        allowSearch
        options={masterData.data?.leadTypes || []}
        valueField="_id"
        labelField="name"
      /> */}
      <MultiSelectFilter
        label="Created By"
        filterKey="createdBy"
        key="createdBy"
        allowSearch
        options={userList || []}
        valueField="value"
        labelField="name"
      />
      {/* <MultiSelectFilter
        label="Approved By"
        filterKey="approvedBy"
        key="approvedBy"
        allowSearch
        options={userList || []}
        valueField="value"
        labelField="name"
      /> */}
      {/* <MultiSelectFilter
        label="Rejected By"
        filterKey="rejectedBy"
        key="rejectedBy"
        allowSearch
        options={userList || []}
        valueField="value"
        labelField="name"
      /> */}
      {/* <MultiSelectFilter
        label="Uploaded By"
        filterKey="uploadedBy"
        key="uploadedBy"
        allowSearch
        options={userList || []}
        valueField="value"
        labelField="name"
      /> */}
      <MultiSelectFilterWithApiSearch
        label="Company"
        filterKey="companyIds"
        key="company"
        allowSearch
        loadData={async (query) => {
          const response = await api.company.searchCompanyInline({ query }) as any ;
          return [...response?.tenants];
        }}
        removeUnassigned
      />,
      <SingleSelectFilter
        label="Property Type"
        filterKey={"propertyTypeKey"}
        key={"name"}
        allowSearch
        options={
          allPropertyType?.reduce((acc: any, item: any) => {
            acc.push(
              ...item.subTypes.map(
                (subType: { propertyTypeKey: any; propertyTypeName: any }) => ({
                  value: subType.propertyTypeKey,
                  name: decodeHtmlEntities(subType.propertyTypeName),
                })
              )
            );
            return acc;
          }, []) || []
        }
        valueField="value"
        labelField="name"
      />
    </ListFilters>
  );

  const headerActions = [
    <ListHeaderSearch
      placeholder="Customer Name, Lead Title, Company Name"
      serachTerm={search}
      onSearch={(val: string) => {
        onChangeFilter(filters, val, page, perPage, dateFilters, sort);
        setSearch(val);
      }}
      additionalClass="min-w-340"
    />,
    <DateRangeListFilter
      default={dateFilters}
      onChange={(d?: IDateRange) => {
        setDateFilters({
          startDate: d?.startDate,
          endDate: d?.endDate,
        });
        if (loaded) {
          onChangeFilter(
            filters,
            search,
            page,
            perPage,
            {
              startDate: d?.startDate,
              endDate: d?.endDate,
            },
            sort
          );
        }
      }}
    />,
  ];

  const formatData = (invoices: any[]) =>{
    if(mainTabName === PaidBy.Client){
      return invoices
    }else{
      return invoices.map(item=>({ ...item, invoiceDetails:{ ...item.invoiceDetails,document: item?.invoiceDetails?.seperateDocumentForLandlord }}))
    }
  }

  return (
    <AppLayout>
      <>
        <ListHeader additionalRows={[filterRow]} actions={headerActions}>
          <div className="d-flex align-items-center">
            <h2 className="m-0 d-flex align-items-baseline flex-column">
              Transactions
              {data && (
                <span className="font-xs text-muted font-weight-semibold d-block ml-2 pt-2">
                  {data.count} Total
                  <span className="font-weight-normal ml-1">
                    Updated <Moment fromNow date={data.lastUpdatedAt} />
                  </span>
                  {selected.length > 0 && (
                    <span className="font-weight-normal ml-1">
                      Selected {selected.length} items
                    </span>
                  )}
                </span>
              )}
            </h2>
            <div className="view-switch ml-lg-5 ml-md-4 ml-auto pl-3 d-flex">
              <div className="border rounded-sm d-flex font-normal"></div>
            </div>
          </div>
        </ListHeader>
        <MainTabs
          tabChangeHandler={(tb: PaidBy) => {
            setMainTabName(tb);
          }}
          tabName={mainTabName}
        />
          <span className="border-top"></span>
        <>
          {(!loaded || loading) && (
            <ContainerLoader
              height={window.innerHeight - 300}
            ></ContainerLoader>
          )}
          {loaded && !loading && (
            <ListTable

              data={formatData(data?.data)}
              showColumnSettings
              selectedColumns={leadSettings?.columnSettings?.columns}
              onSort={(sortKey: string, sortOrder?: SortOrder) => {
                setSort({ sortBy: sortKey, sortOrder });
                onChangeFilter(filters, search, page, perPage, dateFilters, {
                  sortBy: sortKey,
                  sortOrder,
                });
              }}
              sort={sort}
              trProps={(d: LeadRequirement) => {
                return {
                  className: classnames({
                    // "cursor-pointer": true,
                  }),
                  onClick: () => {
                    // 
                  },
                };
              }}
              onColumnSettingsSaved={saveColumnSettings}
            >
              {tableContent}
            </ListTable>
          )}
          <Pagination
            currentPage={page}
            totalPages={data?.totalPages}
            onPageChange={(pg: number) => {
              setPage(pg);
              onChangeFilter(filters, search, pg, perPage, dateFilters, sort);
            }}
            perPage={perPage}
            onPerPageChange={(pg: number) => {
              setPerPage(pg);
              onChangeFilter(filters, search, page, pg, dateFilters, sort);
            }}
            count={data?.count}
            label="transactions"
          />
        </>
        
      </>
    </AppLayout>
  );
};

export default TransactionList;
